"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgTraffic(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "8 0 8 24" }, props),
        React.createElement("path", { d: "M12 4c2.21 0 4 1.79 4 4v8c0 2.21-1.79 4-4 4s-4-1.79-4-4V8c0-2.21 1.79-4 4-4zm0 10a2 2 0 10-.001 3.999A2 2 0 0012 14zm0 1a1 1 0 110 2 1 1 0 010-2zm0-5a1.5 1.5 0 10.001 3.001A1.5 1.5 0 0012 10zm0-4a1.5 1.5 0 10.001 3.001A1.5 1.5 0 0012 6z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Traffic')(SvgTraffic);
//# sourceMappingURL=Traffic.js.map